import { render, staticRenderFns } from "./FormInput.vue?vue&type=template&id=96544a02&scoped=true"
import script from "./FormInput.vue?vue&type=script&lang=js"
export * from "./FormInput.vue?vue&type=script&lang=js"
import style0 from "./FormInput.vue?vue&type=style&index=0&id=96544a02&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96544a02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/centurygame/web-vip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96544a02')) {
      api.createRecord('96544a02', component.options)
    } else {
      api.reload('96544a02', component.options)
    }
    module.hot.accept("./FormInput.vue?vue&type=template&id=96544a02&scoped=true", function () {
      api.rerender('96544a02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/form/FormInput.vue"
export default component.exports